import './index.scss'
import React from 'react'
import BaseStructure from '../base'
import Collapse from './collapse'
import Brand from "./brand"
import ActionButtons from './action-buttons'

export class HeaderStructure extends BaseStructure {
  constructor(props) {
    super(HeaderStructure.formatState(props))
    this.customize = this.props.meta.header_customize
  }

  static initMetaHeader = (props) => {
    return props.meta.header ? props.meta.header : {actions: []}
  }

  static formatState = (props) => {
    const nav = BaseStructure.formatSiteNavLinks(props.nav, props.host)
    let state = Object.assign({}, props, {nav: nav})
    //
    const meta = Object.assign({}, state.meta, {header: HeaderStructure.initMetaHeader(props)})
    state = Object.assign({}, state, {meta: meta})
    //
    return state
  }
  
  // 预设
  presets() {
    const brand = <Brand {...this.props.meta}/>
    const collapsed = <Collapse target="#navbar-collapse" />
    const customizeStyles = this.customizeDesignStyles()
    const headerActions = this.props.meta.header.actions
    // 预设列表
    return [{
      uid: '1',
      html: (
        <nav className="navbar navbar-default" style={customizeStyles}>
          <div className="container">
            <div className="navbar-header">
              { collapsed }
              <Brand {...this.props.meta} />
            </div>

            <div className="collapse navbar-collapse" aria-expanded="false" id="navbar-collapse">
              {headerActions.length > 0 && <ActionButtons className="navbar-right" {...this.props.meta.header} />}
              
              <ul className="nav navbar-nav navbar-right">
                {this.props.nav.map((link, index) =>
                  <li key={ 'header-2-' + index }>
                    <a href={link.url}>{link.title}</a>
                  </li>
                )}
              </ul>
            </div>
          </div>
        </nav>
      )
    }, {
      uid: '2',
      html: (
        <nav className="navbar navbar-default" style={customizeStyles}>
          <div className="container">
            <div className="navbar-header">
              { collapsed }
              { brand }
            </div>

            <div className="collapse navbar-collapse" aria-expanded="false" id="navbar-collapse">
              <ul className="nav navbar-nav">
                {this.props.nav.map((link, index) =>
                  <li key={ 'header-2-' + index }>
                    <a href={link.url}>{link.title}</a>
                  </li>
                )}
              </ul>

              {headerActions.length > 0 && <ActionButtons className="navbar-right" {...this.props.meta.header} />}
            </div>
          </div>
        </nav>
      )
    }, {
      uid: '3',
      html: (
        <nav className="navbar navbar-default" style={customizeStyles}>
          <div className="container">
            <div className="navbar-header">
              { collapsed }
              { brand }
            </div>

            <div className="collapse navbar-collapse" aria-expanded="false" id="navbar-collapse">
              <ul className="nav navbar-nav navbar-right">
                {this.props.nav.map((link, index) =>
                  <li key={ 'header-3-' + index }>
                    <a href={link.url}>{link.title}</a>
                  </li>
                )}
              </ul>
            </div>
          </div>
        </nav>
      )
    }, {
      uid: '4',
      html: (
        <div className="site-brand-highlight" style={customizeStyles}>
          <a href="/" className="site-logo">
            <img className="site-logo-image" src={this.props.meta.logo.src} />
          </a>
          <div className="container">
            <div className="collapse navbar-collapse" aria-expanded="false" id="navbar-collapse">
              <ul className="nav navbar-nav">
                {this.props.nav.map((link, index) =>
                  <li key={ 'header-4-' + index }>
                    <a href={link.url}>{link.title}</a>
                  </li>
                )}
              </ul>
            </div>
          </div>
        </div>
      )
    }]
  }
}

export default HeaderStructure


// WEBPACK FOOTER //
// ./app/javascript/app/site/structures/header/index.js